module.exports = __webpack_public_path__ + "static/media/formacion.ff03cf5c.svg";